"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styles = __importStar(require("./Search.css"));
const SearchContextType_1 = require("./SearchContextType");
const FiltersPanel_1 = __importDefault(require("./FiltersPanel"));
const ConnectedSearch_1 = __importDefault(require("./ConnectedSearch"));
const constants_1 = require("../constants");
const ControlledSearch = (props) => {
    const { config, placeholder, value, customFilters, customComponents, onChange, onApply, onClear, onClearAllFilters, showFreeText, showClearAllFilters, applyOnClear, } = props;
    const showFreeTextSearch = showFreeText !== null && showFreeText !== void 0 ? showFreeText : true;
    const contextValue = {
        state: value,
        update: (updater) => {
            onChange((0, SearchContextType_1.applyUpdater)(value, updater, config));
        },
        updateAndSearch: (updater) => {
            const newState = (0, SearchContextType_1.applyUpdater)(value, updater, config);
            onChange(newState);
            onApply(newState);
        },
        search: () => {
            onApply(value);
        },
        cancel: () => {
            onChange(value);
        },
        clearAndSearch: () => {
            const clearedState = Object.assign(Object.assign({}, value), { filters: {}, customFilters: {} });
            onClearAllFilters(clearedState);
            onApply(clearedState);
        },
        clearSearchTerm: (updater) => {
            const newState = (0, SearchContextType_1.applyUpdater)(value, updater, config);
            if (applyOnClear) {
                onApply(newState);
            }
            else {
                onClear(newState);
            }
        },
    };
    return (React.createElement(SearchContextType_1.SearchContext.Provider, { value: contextValue },
        React.createElement("div", { className: `${styles.search} ${constants_1.ANG_CSS_PREFIX}`, "data-test-id": 'controlled-search' },
            showFreeTextSearch && React.createElement(ConnectedSearch_1.default, { placeholder: placeholder }),
            React.createElement(FiltersPanel_1.default, { config: config, customFilters: customFilters, customComponents: customComponents, showClearAllFilters: showClearAllFilters }))));
};
exports.default = ControlledSearch;
